<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card body-class="p-0">
          <template v-slot:body>
            <div class="iq-edit-list">
              <tab-nav
                :pills="true"
                class="iq-edit-profile d-flex nav-justified"
              >
                <tab-nav-items
                  class="p-0"
                  :class="isErrorExists('vehicle')"
                  :active="step == 1"
                  href="#quickQuote"
                  title="Quick quote"
                  v-on:click.native="fnGetNext(1)"
                />
                <tab-nav-items
                  class="p-0"
                  :class="isErrorExists('client')"
                  :active="step == 2"
                  href="#personalDetails"
                  title="Personal details"
                  v-on:click.native="fnGetNext(2)"
                />
                <tab-nav-items
                  class="p-0"
                  :class="isErrorExists('employment')"
                  :active="step == 3"
                  href="#employmentDetails"
                  title="Employment details"
                  v-on:click.native="fnGetNext(3)"
                />
                <tab-nav-items
                  class="p-0"
                  :class="isErrorExists('finance')"
                  :active="step == 4"
                  href="#financialDetails"
                  title="Financial details"
                  v-on:click.native="fnGetNext(4)"
                />
                <tab-nav-items
                  class="p-0"
                  :class="isErrorExists('notes')"
                  :active="step == 5"
                  href="#docsAndSubmit"
                  title="Doc's & submit"
                  v-on:click.native="fnGetNext(5)"
                />
              </tab-nav>
            </div>
          </template>
        </iq-card>
      </b-col>
      <b-col lg="12">
        <div class="iq-edit-list-data">
          <tab-content id="pills-tabContent-2">
            <tab-content-item
              :active="step == 1"
              id="quickQuote"
              v-show="step == 1"
            >
              <iq-card :class="isErrorExists('vehicle')">
                <template v-slot:body>
                  <div v-if="getQuoteSingle">
                    <appQuoteStep1
                      :propsMode="mode"
                      :propsData="getQuoteSingle"
                      :quoteType="quoteType"
                      ref="quoteStep1"
                    ></appQuoteStep1>
                  </div>
                </template>
              </iq-card>
            </tab-content-item>
            <tab-content-item
              :active="step == 2"
              id="personalDetails"
              v-show="step == 2"
            >
              <iq-card :class="isErrorExists('client')">
                <template v-slot:body>
                  <div v-if="getQuoteSingle">
                    <appQuoteStep2
                      :propsMode="mode"
                      :propsData="getQuoteSingle"
                      :quoteType="quoteType"
                      ref="quoteStep2"
                    ></appQuoteStep2>
                  </div>
                </template>
              </iq-card>
            </tab-content-item>
            <tab-content-item
              :active="step == 3"
              id="employmentDetails"
              v-show="step == 3"
            >
              <iq-card :class="isErrorExists('employment')">
                <template v-slot:body>
                  <div v-if="getQuoteSingle">
                    <appQuoteStep3
                      :propsMode="mode"
                      :propsData="getQuoteSingle"
                      :quoteType="quoteType"
                      ref="quoteStep3"
                    ></appQuoteStep3>
                  </div>
                </template>
              </iq-card>
            </tab-content-item>
            <tab-content-item
              :active="step == 4"
              id="financialDetails"
              v-show="step == 4"
            >
              <iq-card :class="isErrorExists('finance')">
                <template v-slot:body>
                  <div v-if="getQuoteSingle">
                    <appQuoteStep4
                      :propsMode="mode"
                      :propsData="getQuoteSingle"
                      :quoteType="quoteType"
                      ref="quoteStep4"
                    ></appQuoteStep4>
                  </div>
                </template>
              </iq-card>
            </tab-content-item>
            <tab-content-item
              :active="step == 5"
              id="docsAndSubmit"
              v-show="step == 5"
            >
              <iq-card :class="isErrorExists('notes')">
                <template v-slot:body>
                  <div v-if="getQuoteSingle">
                    <appQuoteStep5
                      :propsMode="mode"
                      :propsData="getQuoteSingle"
                      :quoteType="quoteType"
                      ref="quoteStep5"
                    ></appQuoteStep5>
                  </div>
                </template>
              </iq-card>
            </tab-content-item>
          </tab-content>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import appQuoteStep1 from '../../components/quote/step1.vue'
import appQuoteStep2 from '../../components/quote/step2.vue'
import appQuoteStep3 from '../../components/quote/step3.vue'
import appQuoteStep4 from '../../components/quote/step4.vue'
import appQuoteStep5 from '../../components/quote/step5.vue'
export default {
  name: 'QuoteEdit',
  props: ['quoteType'],
  components: {
    appQuoteStep1,
    appQuoteStep2,
    appQuoteStep3,
    appQuoteStep4,
    appQuoteStep5
  },
  data() {
    return {
      quoteId: this.$route.params.quoteId,
      mode: 'edit',
      step: 1,
      isErrorStep: 2
    }
  },
  computed: {
    ...mapGetters(['getStepNumber', 'getQuoteSingle', 'getQuoteErrors'])
  },
  methods: {
    ...mapActions(['fetchQuoteSingle', 'fetchStepNumber']),
    fnSections() {
      if (this.step == 1) {
        this.toggleAddClass('#quickQuote')
        this.toggleRemoveClass('#personalDetails')
        this.toggleRemoveClass('#employmentDetails')
        this.toggleRemoveClass('#financialDetails')
        this.toggleRemoveClass('#docsAndSubmit')
      } else if (this.step == 2) {
        this.toggleRemoveClass('#quickQuote')
        this.toggleAddClass('#personalDetails')
        this.toggleRemoveClass('#employmentDetails')
        this.toggleRemoveClass('#financialDetails')
        this.toggleRemoveClass('#docsAndSubmit')
      } else if (this.step == 3) {
        this.toggleRemoveClass('#quickQuote')
        this.toggleRemoveClass('#personalDetails')
        this.toggleAddClass('#employmentDetails')
        this.toggleRemoveClass('#financialDetails')
        this.toggleRemoveClass('#docsAndSubmit')
      } else if (this.step == 4) {
        this.toggleRemoveClass('#quickQuote')
        this.toggleRemoveClass('#personalDetails')
        this.toggleRemoveClass('#employmentDetails')
        this.toggleAddClass('#financialDetails')
        this.toggleRemoveClass('#docsAndSubmit')
      } else if (this.step == 5) {
        this.toggleRemoveClass('#quickQuote')
        this.toggleRemoveClass('#personalDetails')
        this.toggleRemoveClass('#employmentDetails')
        this.toggleRemoveClass('#financialDetails')
        this.toggleAddClass('#docsAndSubmit')
      }
    },
    toggleAddClass(url) {
      this.toggleRemoveClass('#quickQuote')
      this.toggleRemoveClass('#personalDetails')
      this.toggleRemoveClass('#employmentDetails')
      this.toggleRemoveClass('#financialDetails')
      this.toggleRemoveClass('#docsAndSubmit')

      var el = document.querySelector(`.iq-edit-list a[href="${url}"].nav-link`)
      el.classList.add('active')
    },
    toggleRemoveClass(url) {
      var el = document.querySelector(
        `.iq-edit-list a[href="${url}"].nav-link.active`
      )

      if (el) {
        el.classList.remove('active')
      }
    },
    fnGetNext(stepNumber) {
      this.step = stepNumber
      this.fetchStepNumber(stepNumber)
      this.fnSections()
    },
    isErrorExists(isErrorStep) {
      let res = Object.keys(this.getQuoteErrors).filter((v) =>
        v.startsWith(isErrorStep)
      )

      console.log(res)

      if (res.length > 0) {
        return 'hasErrors'
      }

      return ''
    }
  },
  created() {
    this.fetchQuoteSingle({ id: this.quoteId, quoteType: this.quoteType })
  },
  watch: {
    getStepNumber: function (newVale, oldValue) {
      this.step = newVale

      if (oldValue == 0 || oldValue == 1) {
        this.$refs.quoteStep1.fnSaveApplication()
      }
      if (oldValue == 2) {
        this.$refs.quoteStep2.fnSaveApplication()
      }
      if (oldValue == 3) {
        this.$refs.quoteStep3.fnSaveApplication()
      }
      if (oldValue == 4) {
        this.$refs.quoteStep4.fnSaveApplication()
      }
      if (oldValue == 5) {
        this.$refs.quoteStep5.fnSaveApplication()
      }
      this.fnSections()
    }
  }
}
</script>
<style scoped>
.iq-card.hasErrors,
.nav-item.hasErrors {
  border: 1px red solid;
}
.iq-edit-list li:first-child.hasErrors,
.iq-edit-list li:last-child.hasErrors {
  border: 1px red solid;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
</style>
